// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__zXNYQ","title":"style__title__nLE3a","description":"style__description__mbpIp","component":"style__component__e4F3C"};